import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackgroundGrid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 185,
	height: 128,
	viewBox: "0 0 185 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 185,
			height: 127.567,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1992 101.224H173.799",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1992 77.6079H173.799",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1992 53.9918H173.799",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1992 30.3755H173.799",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.7852 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.426 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.068 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.709 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.1445 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.5078 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8672 118.357V9.20929",
			stroke: "#C2C9D6",
			strokeWidth: 1.31121
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 185,
			height: 127.567,
			fill: "url(#paint0_linear_302_11202)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_302_11202",
			x1: 9.00668,
			y1: 63.7833,
			x2: 176.475,
			y2: 63.7833,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .493625,
					stopColor: "white",
					stopOpacity: .85
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})
			]
		}) })
	]
});
export default SvgBackgroundGrid;
